// 气象仪接口

import request from '@utils/request'

const url = 'api/Weather/'

/**
 *
 * 配置指定的气象仪安装了哪些模块
 * @export
 * @param {*} data
 * @return {*}
 */
export function SetWeatherModules (data) {
  return request({
    url: url + 'SetWeatherModules',
    method: 'post',
    data
  })
}

/**
 *
 * 分页查询气象站的设备列表，或者也叫实时列表（气象站 - 设备/实时）
 * @export
 * @param {*} data
 * @return {*}
 */
export function QueryWeathereReals (data) {
  return request({
    url: url + 'QueryWeathereReals',
    method: 'post',
    data
  })
}

/**
 *
 * 获取指定设备的天气最新数据（气象站 - 设备详情）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetWeatherDetailsByGatewayId (data) {
  return request({
    url: url + 'GetWeatherDetailsByGatewayId',
    method: 'post',
    data
  })
}

/**
 *
 * 获取气象历史数据（气象站 - 对比分析/数据查询）
 * @export
 * @param {*} data
 * @return {*}
 */
export function GetWeatherHistorys (data) {
  return request({
    url: url + 'GetWeatherHistorys',
    method: 'post',
    data
  })
}

/**
 *
 * 导出气象历史数据（气象站 - 数据查询）
 * @export
 * @param {*} data
 * @return {*}
 */
export function ExpWeatherHistorys (data) {
  return request({
    url: url + 'ExpWeatherHistorys',
    method: 'post',
    data
  })
}
